import styled from 'styled-components/macro';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
export const CalendarWrapperStyled = styled.div `
  margin-top: ${INDENT.xxxs};
  position: absolute;
  z-index: ${Z_INDEX.level1};
`;
